module.exports = __webpack_public_path__ + "static/media/showroom-background-1.7f0db576.jpg";